module.exports = __webpack_public_path__ + "media/images/animations/tire_widths/1-1af572634ae06705efe4b0225b4d8133.png";